import { getAction, postAction } from '../http'

//pay
export default {
  aliPay(params = {}) {
    return getAction('/api/aliPay/pcPay',params);
  },
  wxPay(params = {}) {
    return getAction('/api/wechat/scanCode2',params);
  },
}